import { Box, Stack, Typography } from '@mui/material'
import { useState } from 'react'
import { BsPlusCircleDotted } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { IInventoryItemBrand } from 'shared/types'
import * as Yup from 'yup'
import Catalog from '../../../../../../api/db/Catalog'
import { selectCurrrentAdminShop } from '../../../../../../store/features/currentBusinessShop'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { InputFileCustomChild } from '../../../../../molecules/Input'
import { ValidatedButton, ValidatedForm, ValidatedTextInput } from '../../../../../organisms/validation/admin'


const initialValues = {
    name: ""
}

const validationSchema= Yup.object().shape({
    name: Yup.string().required().label("name")
})

interface IAddProductBrandFormProps{
    onDone: (arg?: any)=>void;
    onFail: (reason: any)=>void;
}

export default function AddProductBrandForm({onDone, onFail}:IAddProductBrandFormProps) {

    const [isLoading, setIsLoading] = useState(false)
    const user_id = useSelector(selectUserPropsState)?.uid
    const current_shop = useSelector(selectCurrrentAdminShop)?.name
    

    const handleOnSubmit = async ({name}:{name:string})=>{

        try {
            
            setIsLoading(true)
            await Catalog.addBrand(name, user_id, current_shop)
            setIsLoading(false)
            onDone()
            
        } catch (error: any) {
            setIsLoading(false)
            onFail(error)
        }
        
    }

    const handleOnSubmitBulk = async (data: {[key:string]:any}[])=>{
        try {

            setIsLoading(true)
            await Catalog.addBrandBulk(data as IInventoryItemBrand[], user_id, current_shop)
            onDone()
            setIsLoading(false)
            
        } catch (error) {
            setIsLoading(false)
            onFail(error)
        }
    }

    const handleOnSubmitBulkFail = async ()=>{

    }
    
    return (
        <ValidatedForm
            onSubmit={handleOnSubmit}
            initialValues={initialValues}
            validationSchema={validationSchema}
        >

            <Box
            >
                
                <Stack 
                    direction="row"
                    sx={{width: "100%", marginBottom: "1rem"}}
                    spacing={2}
                >
                    <Stack sx={{width: "100%"}}>
                        <Typography variant="subtitle2" color="grey.500">Category name</Typography>
                        <ValidatedTextInput name="name" type="text" />
                    </Stack>
                </Stack>

                <Box
                    sx={{marginTop: "1.5rem", display: "flex", justifyContent: "flex-end"}}
                >

                    <Box
                        sx={{display: "inline", marginRight: "1rem"}}
                    >
                        <InputFileCustomChild 
                            accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel' 
                            onChange={handleOnSubmitBulk}
                            onFail={handleOnSubmitBulkFail}
                        >
                            <Typography sx={{textDecoration: "underline"}} variant='subtitle2' color="grey.100" >Upload from spreadsheet</Typography>
                        </InputFileCustomChild>
                    </Box>
                    
                    <ValidatedButton 
                        startIcon={<BsPlusCircleDotted />} 
                        variant="contained" 
                        color="secondary" 
                        disableElevation={true}
                        loading={isLoading}
                    >
                        <Typography  color="primary" >Add</Typography>
                    </ValidatedButton>
                </Box>

            </Box>
            
        </ValidatedForm>
    )
}
